/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ServiceTypeEnum } from './serviceTypeEnum';
import { OAuthAppAwsAccountCategoryEnum } from './oAuthAppAwsAccountCategoryEnum';


export interface SeedOAuthAppCopyCredentialsSpec { 
    /**
     * Org id
     */
    org_id: string;
    service_type: ServiceTypeEnum;
    source_aws_account_type: OAuthAppAwsAccountCategoryEnum;
    /**
     * Shadow account region in which credentials need to be copied
     */
    targeted_shadow_account_region: string;
}
export namespace SeedOAuthAppCopyCredentialsSpec {
}


